import { render, staticRenderFns } from "./challenge.vue?vue&type=template&id=02717728&scoped=true"
import script from "./challenge.vue?vue&type=script&lang=js"
export * from "./challenge.vue?vue&type=script&lang=js"
import style0 from "./challenge.vue?vue&type=style&index=0&id=02717728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02717728",
  null
  
)

export default component.exports